import * as moment from 'moment';

const dateSeparator = '-';

export class DateHelper {
  static format(date: moment.Moment | string, includeTime = false) {
    const momentDate = moment(date);
    if (includeTime) {
      return momentDate.format(`DD${dateSeparator}MM${dateSeparator}YYYY HH:mm:ss`);
    } else {
      return momentDate.format(`DD${dateSeparator}MM${dateSeparator}YYYY`);
    }
  }

  static getTodaysDate() {
    return this.format(moment());
  }
}
